// src/components/NavigationSteps.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  CarOutlined,
  CheckCircleOutlined,
  DeploymentUnitOutlined,
  DesktopOutlined,
  EnvironmentOutlined,
  CompassOutlined,
} from "@ant-design/icons";
import { Card, Typography } from "antd";

const { Text } = Typography;

/**
 * @param {string} selectedKey - la clé (ou chemin) de l'étape sélectionnée
 */
export const NavigationStepsCds= ({ selectedKey }) => {
  // Liste ordonnée des étapes
  const steps = [
    {
      key: "tetra_bus",
      title: "Temp 1",
      label: "Validation TETRA BUS",
      path: "/cds/tetra_bus",
      icon: <CarOutlined />,
    },
    {
      key: "po_siel",
      title: "Temp 1",
      label: "Validation PO Siel",
      path: "/cds/po_siel",
      icon: <CheckCircleOutlined />,
    },
    {
      key: "prise_service",
      title: "Temp 2",
      label: "Validation Prise de service SAE (1/2)",
      path: "/cds/prise_service",
      icon: <DeploymentUnitOutlined />,
    },
    {
      key: "prise_service_coquille",
      title: "Temp 2",
      label: "Validation Prise de service SAE (2/2)",
      path: "/cds/prise_service_coquille",
      icon: <DeploymentUnitOutlined />,
    },
    {
      key: "po_siel_sesco",
      title: "Temp 2",
      label: "Validation PO SIEL CESCO",
      path: "/cds/po_siel_sesco",
      icon: <DesktopOutlined />,
    },
    {
      key: "po_siel_ad",
      title: "Temp 2",
      label: "Validation PO SIEL salle AD",
      path: "/cds/po_siel_ad",
      icon: <DesktopOutlined />,
    },
    {
      key: "geolocalisation",
      title: "Temp 3",
      label: "Géolocalisation de l'AD",
      path: "/cds/geolocalisation",
      icon: <EnvironmentOutlined />,
    },
    /*
    {
      key: "tetra",
      title: "Temp 4",
      label: "Suivi des tests AD",
      path: "/cds/tetra",
      icon: <CompassOutlined />,
    },
    */
    {
      key: "coquille_config_dsp",
      title: "Tests AD",
      label: "Coquille Config Dsp",
      path: "/all/coquille_config_dsp",
      icon: <CompassOutlined />,
    },
  ];

  return (
    <div style={{ 
      position: "sticky",
      top: "68px",
      zIndex: 1000,
      backgroundColor: "#fff",
      paddingTop: "15px",
      paddingBottom: "15px",
      marginBottom: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
    }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          justifyContent: "center",
        }}
      >
      {steps.map((step) => {
        const active = selectedKey === step.key;

        return (
          <Link
            key={step.key}
            to={step.path}
            style={{ textDecoration: "none" }}
          >
            <Card
              hoverable
              size="small"
              style={{
                width: 180,
                height: 90, // 🔹 moins haut qu'avant
                borderRadius: 10,
                boxShadow: active
                  ? "0 0 8px rgba(24, 144, 255, 0.6)"
                  : "0 1px 5px rgba(0,0,0,0.1)",
                borderColor: active ? "#1677ff" : "#f0f0f0",
                transition: "all 0.2s ease",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: 22, color: active ? "#1677ff" : "#999" }}>
                {step.icon}
              </div>
              <Text strong style={{ fontSize: 13 }}>
                {step.title}
              </Text>
              <div style={{ fontSize: 11, color: "#666", marginTop: 2 }}>
                {step.label}
              </div>
            </Card>
          </Link>
        );
      })}
      </div>
    </div>
  );
};
